<div id="home" class="{{activeHome}}">
    <audio id="audioSection" controls autoplay loop hidden="hidden">
        <source autoplay="true" src="../../assets/audio/AngelicForest.mp3" type="audio/mp3">
        <!-- Your browser does not support the audio element. -->
    </audio>
    <!-- Section One -->
    <section id="sec1" class="sec1">
        <!-- desktop -->
        <div class="row hide-on-small-only" id="box">
            <div class="layer" id="l1">
                <img class="responsive-img" src="/assets/img/home/sec1/desktop/bg_4.png" alt="">
            </div>
            <div class="layer" id="l2">
                <img class="responsive-img" src="/assets/img/home/sec1/desktop/bg_3.png" alt="">
            </div>
            <div class="layer" id="l3">	
                <img class="responsive-img" src="/assets/img/home/sec1/desktop/bg_2.png" alt="">
            </div>
            <div class="layer" id="l4">
                <img class="responsive-img" src="/assets/img/home/sec1/desktop/bg_1.png" alt="">
            </div>
            <div class="layer" id="l5">
                <img class="responsive-img" src="/assets/img/home/sec1/desktop/logo_desktop.png" alt="">
            </div>
        </div>
        
        <!-- mobile -->
        <div class="row hide-on-med-and-up" id="boxm">
        
            <div class="keyart" id="parallax">
                <div class="keyart_layer parallax" id="keyart-0" data-speed="2">
                    <img class="responsive-img" src="/assets/img/home/sec1/mobile/bg_4.png" alt="">
                </div>	
                <div class="keyart_layer parallax" id="keyart-1" data-speed="5">
                    <img class="responsive-img" src="/assets/img/home/sec1/mobile/bg_3.png" alt="">
                </div>
                <div class="keyart_layer parallax" id="keyart-2" data-speed="11">
                    <img class="responsive-img" src="/assets/img/home/sec1/mobile/bg_2.png" alt="">
                </div>	
                <div class="keyart_layer parallax" id="keyart-3" data-speed="16">
                    <img class="responsive-img" src="/assets/img/home/sec1/mobile/bg_1.png" alt="">
                </div>
                <div class="keyart_layer parallax" id="keyart-4" data-speed="26">
                    <img class="responsive-img" src="/assets/img/home/sec1/mobile/logo.png" alt="">
                </div>	
                
            </div>
        </div>
    </section>

    <!-- section two -->
    <section id="sec2">
        
        <!-- desktop -->
        <div class="keyart" id="parallax2">
            <div class="keyart_layer parallax hide-on-small-only" id="keyart-5" data-speed="2">
                <img class="responsive-img" src="assets/img/home/sec2/desktop/up.png" alt="">
            </div>	
        </div>
        
        <div class="flexbox-container hide-on-small-only">
            <div class="flexbox-item fixed">
                <div class="row">
                    <div class="col m10 l12 offset-m1">
                        <div class="content center-align">
                            <h2 class="contentToShowFirst animated">
                                Encontrando nuevos y mejores usos
                            </h2>
                            <h5 class="contentToShowSecond animated">
                                Somos una agencia creativa especializada en desarrollo web.
                            </h5>
                            <p class="contentToShowThird animated">
                                Nos asociamos con marcas locales y negocios emergentes para crear excitantes y maginificas experiencias, ya sea digital o no.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

        <!-- mobile -->
        <div class="row hide-on-med-and-up">
            <div class="col s12">
                <div class="keyart_layer parallax hide-on-med-and-up" id="keyart-6" data-speed="5">
                    <img class="responsive-img" src="assets/img/home/sec2/mobile/up.png" alt="">
                </div>	
                <div class="mobile-content center-align">
                    <h4 class="contentToShowFirst animated">
                        Encontrando nuevos y mejores usos
                    </h4>
                    <h5 class="contentToShowSecond animated">
                        Somos una agencia creativa especializada en desarrollo web.
                    </h5>
                    <p class="contentToShowThird animated">
                        Nos asociamos con marcas locales y negocios emergentes para crear excitantes y maginificas experiencias, ya sea digital o no.
                    </p>
                </div>
                <div>
                    <img class="responsive-img" src="assets/img/home/sec2/mobile/down.png" alt="">
                </div>
            </div>
        </div>
                
    </section>

    <!-- Section three -->
    <section id="sec3">
        
        <div class="row">
            <!-- desktop -->
            <div class="hide-on-small-only">
                <img class="responsive-img" src="assets/img/home/sec3/desktop/up.png">
                
                <h2 class="contentToShowFirst animated text-center">
                    Proyectos desarrollados
                </h2>
            </div>
            <!-- mobile -->
            <div class="hide-on-med-and-up">
                <img class="responsive-img" src="assets/img/home/sec3/mobile/up.png">
                <h4 class="contentToShowFirst animated text-center">
                    Proyectos desarrollados
                </h4>
            </div>
        </div>

        <div class="keyart contentToShowThird" id="parallax3">
            <div class="keyart_layer parallax hide-on-small-only" id="keyart-8" data-speed="6">
                <img class="responsive-img" src="assets/img/home/sec3/desktop/bg_circles.png" alt="">
            </div>	
            <div class="keyart_layer parallax hide-on-med-and-up" id="keyart-9" data-speed="4">
                <img class="responsive-img" src="assets/img/home/sec3/mobile/bg-circles.png" alt="">
            </div>	
        </div>

        <div class="row">
            <!-- desktop -->
            <div id="slider" class="slider hide-on-small-only">
                <div class="slider-content">
                    <div class="slider-content-wrapper">
                    <!-- desktop -->
                        <div class="slider-content__item hide-on-small-only" *ngFor="let chunk of chunkProjects">
                            <div class="row">
                                <div class="col s12 m8 l6 offset-m2 offset-l3 contentToShowSecond animated">
                                    <div class="col s12 m6 l6" *ngFor="let project of chunk">
                                        <div class=" card">
                                            <div class="card-image waves-effect waves-block waves-light">
                                                <img class="activator" src="{{project.url}}">
                                            </div>
                                            <div class="card-content">
                                                <span class="card-title activator grey-text text-darken-4">{{project.title}}<i class="material-icons right">more_vert</i></span>
                                                <p>{{project.description | slice:0:50}}...</p>
                                                <a class="waves-effect waves-light btn-floating right teal lighten-3" href="{{project.link}}" target="_blank"><i class="material-icons">cloud_queue</i></a>
                                                <!-- <p><a href="#">This is a link</a></p> -->
                                            </div>
                                            <div class="card-reveal">
                                                <span class="card-title grey-text text-darken-4">{{project.title}}<i class="material-icons right">close</i></span>
                                                <p>{{project.description}}</p>
                                                <div class="row link-reveal">
                                                    <div class="col s12  teal lighten-3">
                                                        <a class="white-text" href="{{project.link}}" target="_blank">
                                                            <div class="left a"><i class="material-icons">cloud_queue</i></div> 
                                                            <div class="text-center b">Ver en la web</div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="prev-arrow" class="prev-arrow d-none">
                        <svg viewBox="0 0 256 512">
                            <path fill="currentColor"
                                d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z">
                            </path>
                        </svg>
                    </div>
                    <div id="next-arrow" class="next-arrow">
                        <svg viewBox="0 0 256 512">
                            <path fill="currentColor"
                                d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z">
                            </path>
                        </svg>
                    </div>
                </div>
            </div>
            <!-- mobile -->
            <div id="slider-mobile" class="slider hide-on-med-and-up contentToShowSecond">
                <div class="slider-content-mobile slider-content">
                    <div class="slider-content-mobile-wrapper slider-content-wrapper">
                        <!-- mobile -->
                        <div class="slider-content-mobile__item animated hide-on-med-and-up" *ngFor="let project of projects">
                            <div class="row">
                                <div class="col s8 offset-s2">
                                    <div class=" card">
                                        <div class="card-image waves-effect waves-block waves-light">
                                            <img class="activator" src="{{project.url}}">
                                        </div>
                                        <div class="card-content">
                                            <span class="card-title activator grey-text text-darken-4">{{project.title}}<i class="material-icons right">more_vert</i></span>
                                            <p>{{project.description | slice:0:50}}...</p>
                                            <!-- <p><a href="#">This is a link</a></p> -->
                                            <a class="waves-effect waves-light btn-floating right teal lighten-3" href="{{project.link}}" target="_blank"><i class="material-icons">cloud_queue</i></a> 
                                        </div>
                                        <div class="card-reveal">
                                            <span class="card-title grey-text text-darken-4">{{project.title}}<i class="material-icons right">close</i></span>
                                            <p>{{project.description}}</p>
                                            <div class="row link-reveal">
                                                <div class="col s12  teal lighten-3">
                                                    <a class="white-text" href="{{project.link}}" target="_blank">
                                                        <div class="left a"><i class="material-icons">cloud_queue</i></div> 
                                                        <div class="text-center b">Ver en la web</div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="prev-arrow-m" class="prev-arrow d-none">
                        <svg viewBox="0 0 256 512">
                            <path fill="currentColor"
                                d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z">
                            </path>
                        </svg>
                    </div>
                    <div id="next-arrow-m" class="next-arrow">
                        <svg viewBox="0 0 256 512">
                            <path fill="currentColor"
                                d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z">
                            </path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>

    </section>

    <!-- Section four -->
    <section id="sec4">
            <div class="relative">
            </div>
            <!-- desktop -->
            <div class="landscape" id="landscape">
                
                
                <div class="hide-on-small-only tabletAndDesktop">
                    <!-- clouds -->
                    <!-- desktop -->
                    <div class="hide-on-small-only">
                        <img class="responsive-img up" src="assets/img/home/sec4/desktop/up.png">
                    </div>
        
        
                    <!-- landscape -->            
                    
                    <img class="responsive-img base landscapeAnimateSecond animated hide-on-med-and-down" src="assets/img/home/sec4/desktop/mountain.png" alt="">
                    <img class="responsive-img base landscapeAnimateFirst animated hide-on-med-and-down" src="assets/img/home/sec4/desktop/behind-cave.png" alt="">
                    <img class="responsive-img base landscapeAnimateFirst animated hide-on-med-and-down" src="assets/img/home/sec4/desktop/cave-part1.png" alt="">
        
                    <img class="responsive-img base landscapeAnimateSecond animated hide-on-large-only show-on-medium" src="assets/img/home/sec4/tablet/mountain.png" alt="">
                    <img class="responsive-img base landscapeAnimateFirst animated hide-on-large-only show-on-medium" src="assets/img/home/sec4/tablet/behind-cave.png" alt="">
                    <img class="responsive-img base landscapeAnimateFirst animated hide-on-large-only show-on-medium" src="assets/img/home/sec4/tablet/cave-part1.png" alt="">
                    <div id="train-title" class="row train-title animated">
                        <div class="col s10 m10 l6 offset-s1 offset">
                            <h4 class="white-text text-lighten-3 align-text">
                                Contáctanos
                            </h4>
                        </div>
                    </div>
                    <div id="traindiv" class="row landscapeAnimateThird">
                        <div class="col m7 offset-m5 bottom-zero relative">
                            <div id="train-smoke" class="col m1 offset-m4  train-smoke relative">
                                <div class="col m5 canvas relative">
                                    <!-- <h2>1. Animar con js</h2> -->
                                    <div class="smoke smoke1 align-text" id="smoke1"></div>
                                    <div class="smoke smoke2 align-text" id="smoke2"></div>
                                    <div class="smoke smoke3 align-text" id="smoke3"></div>
                                    <div class="smoke smoke4 align-text" id="smoke4"></div>
                                    <div class="smoke smoke5 align-text" id="smoke5"></div>
                                    <div class="smoke smoke6 align-text" id="smoke6"></div>
                                    <div class="smoke smoke7 align-text" id="smoke7"></div>
                                    <div class="smoke smoke8 align-text" id="smoke8"></div>
                                    <div class="smoke smoke9 align-text" id="smoke9"></div>
                                    <div class="smoke smoke10 align-text" id="smoke10"></div>
                                </div>
                            </div>
                            <div class="col m7 relative">
                                <img id="train-img" class="responsive-img train-img" src="assets/img/home/sec4/desktop/train.png" alt="">
                            </div>
                        </div>
                    </div>
                    <img class="responsive-img base landscapeAnimateSecond animated landscapeAnimateFirst animated hide-on-med-and-down" src="assets/img/home/sec4/desktop/cave-part2.png" alt="">
                    <img class="responsive-img base landscapeAnimateSecond animated hide-on-med-and-down" src="assets/img/home/sec4/desktop/cave-part2-trees.png" alt="">
        
                    <img class="responsive-img base landscapeAnimateSecond animated landscapeAnimateFirst animated hide-on-large-only show-on-medium" src="assets/img/home/sec4/tablet/cave-part2.png" alt="">
                    <img class="responsive-img base landscapeAnimateSecond animated hide-on-large-only show-on-medium" src="assets/img/home/sec4/tablet/cave-part2-trees.png" alt="">
                    
                    <div class="trainway landscapeAnimateThird animated">
                        <div id="train-form" class="row train-form">
                            <form [formGroup]="contactForm" (submit)="sendContact()">
                                <div class="input-field">
                                    <input formControlName="email" id="email" type="email" class="validate">
                                    <label for="email">Ingresa tu correo</label>
                                    <div *ngIf="contactForm.value.email.touched && contactForm.value.email.hasError('email')">El correo es inválido</div>
                                </div>
                                <div class="col s12 m12 l6 relative">
                                    <button id="play" type="submit" class="btn-floating btn-large waves-effect waves-light red lighten-3">
                                        <i class="material-icons">thumb_up_alt</i>
                                    </button>
                                </div>
                                <!-- <div class="col s12 m12 l12">
                                    <a class="btn-large waves-effect waves-light green">
                                        <i class="material-icons">thumb_up_alt</i>
                                    </a>
                                </div> -->
                            </form>
                        </div>
        
                    </div>
                    <div id="train-message" class="row train-message animated">
                        <div class="col s10 m10 l8 offset-s1 offset-m1 offset-l2 ">
                            <h4 class="red-text text-lighten-3 align-text">
                                ¡Gracias por contactarse con nosotros!
                            </h4>
                            <h5 class="red-text text-lighten-2 align-text">
                                Lograremos intercambiar información pronto
                            </h5>
                        </div>
                    </div>
                </div>

                <div id="mobileOnly" class="hide-on-med-and-up mobileOnly">
                    
                    <!-- clouds -->
                    <!-- mobile -->
                    <img class="responsive-img up" src="assets/img/home/sec4/mobile/up.png">
        
                    <!-- landscape -->
                    <img class="responsive-img up landscapeAnimateSecond animated" src="assets/img/home/sec4/mobile/mountain.png" alt="">
                    <img class="responsive-img up landscapeAnimateFirst animated" src="assets/img/home/sec4/mobile/behind-cave.png" alt="">
                    <img class="responsive-img up landscapeAnimateFirst animated" src="assets/img/home/sec4/mobile/cave-part1.png" alt="">
                    <img id="train-img-m" class="responsive-img up landscapeAnimateThird animated" src="assets/img/home/sec4/mobile/train.png" alt="">
                    <img class="responsive-img up landscapeAnimateFirst animated" src="assets/img/home/sec4/mobile/cave-part2.png" alt="">
                    <img class="responsive-img up landscapeAnimateSecond animated" src="assets/img/home/sec4/mobile/cave-part2-trees.png" alt="">
                    <div id="train-title-m" class="row train-title animated">
                        <div class="col s8">
                            <h4 class="white-text text-lighten-3 align-text">
                                Contáctanos
                            </h4>
                        </div>
                    </div>
                    <div class="trainway trainway-m landscapeAnimateThird animated">
                        <div id="train-form-m" class="row train-form train-form-m">
                            <form [formGroup]="contactFormMobile" (submit)="sendContactMobile()">
                                <div class="input-field">
                                    <input formControlName="email" id="email-m" type="email" class="validate">
                                    <label for="email-m">Ingresa tu correo</label>
                                    <div *ngIf="contactFormMobile.value.email.touched && contactFormMobile.value.email.hasError('email')">El correo es inválido</div>
                                </div>
                                <div class="col s12 m12 l6">
                                    <button id="play-m" type="submit" class="btn-large btn-large waves-effect waves-light red lighten-3">
                                        <i class="material-icons left">thumb_up_alt</i> 
                                        <span>Enviar</span>
                                    </button>
                                </div>
                            </form>
                            <!-- <div class="col s12 m12 l12">
                                <a class="btn-large waves-effect waves-light green">
                                    <i class="material-icons">thumb_up_alt</i>
                                </a>
                            </div> -->
                        </div>
        
                    </div>
                    <div id="train-message-m" class="row train-message animated">
                        <div class="col s10 m10 l8 offset-s1 offset-m1 offset-l2 ">
                            <h4 class="red-text text-lighten-3 align-text">
                                ¡Gracias por contactarse con nosotros!
                            </h4>
                            <h5 class="red-text text-lighten-2 align-text">
                                Lograremos intercambiar información pronto
                            </h5>
                        </div>
                    </div>
                </div>

            </div>

            <!-- <div class="keyart" id="parallax4">
                <div class="keyart_layer parallax hide-on-small-only" id="keyart-10" data-speed="10">
                    <img class="responsive-img" src="assets/img/home/sec4/desktop/snow.png" alt="">
                </div>	
            </div> -->
            
            <!-- <div class="keyart_layer parallax hide-on-small-only" id="keyart-9" data-speed="6">
            </div>	 -->
            <!-- <div class="keyart_layer parallax hide-on-med-and-up" id="keyart-9" data-speed="4">
                <img class="responsive-img" src="assets/img/home/sec4/mobile/bg-circles.png" alt="">
            </div>	 -->

    </section>
</div>

